/* Script all functions
------------------------------------------------------------------------------*/

// Function to create and append SVG to an element
const mainHeader = document.querySelector('.main-header');

export const appendSVGBtn = (element, iconId, width, height) => {
	const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	svg.setAttribute('aria-hidden', 'true');
	svg.setAttribute('width', width);
	svg.setAttribute('height', height);
	svg.setAttribute('fill', 'currentColor');

	const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
	use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', iconId);

	svg.appendChild(use);
	element.appendChild(svg);
};

/* Header add class and slide up top bar */
export const headeraddClass = () => {
	const header = document.querySelector('.main-header');
	if (!header) {
		return;
	}

	const handleScroll = () => {
		const currentScroll = window.scrollY;
		if (currentScroll > 10) {
			header.classList.add('stuck');
			header.classList.add('is-revealed');
		} else {
			header.classList.remove('stuck');
		}
	};

	// Bind scroll listener
	window.addEventListener('scroll', handleScroll, { passive: true });
	handleScroll(); // Initial check
};

/* Clear animation fill mode and mark homepage header as revealed */
export const initHeaderAnimation = () => {
	const header = document.querySelector('body.home .main-header');
	if (!header) {
		return;
	}

	const revealHeader = () => {
		header.classList.add('is-revealed');
	};

	header.addEventListener('animationend', (e) => {
		if (e.animationName === 'hhHeaderFadeIn') {
			revealHeader();
		}
	}, { once: true });

	// Fallback timeout in case user scrolls or animation completes
	setTimeout(revealHeader, 2800);
};

/* Prevent home hero animation from re-triggering on resize */
export const initHomeHeroAnimation = () => {
	const hero = document.querySelector('.home-hero');
	if (!hero) {
		return;
	}

	const finishAnimation = () => {
		hero.classList.add('is-animated');
	};

	// Mark animated once background media reveal finishes
	const bgMedia = hero.querySelector('.hh-bg-media');
	if (bgMedia) {
		bgMedia.addEventListener('animationend', () => {
			finishAnimation();
		}, { once: true });
	}

	// Fallback timeout matching $hh-anim-duration (2.8s)
	setTimeout(finishAnimation, 2800);

	// If user resizes the window, immediately complete animation so it doesn't restart
	window.addEventListener('resize', finishAnimation, { passive: true });
};

/* Slide Up, Down and Toggle Fucntion Start */
export const slideUp = (element, duration = 500, callback = null) => {
	const style = window.getComputedStyle(element);
	const paddingTop = style.paddingTop;
	const paddingBottom = style.paddingBottom;
	const marginTop = style.marginTop;
	const marginBottom = style.marginBottom;

	element.style.height = `${element.offsetHeight}px`;
	// element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
	element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
	element.offsetHeight;

	element.style.overflow = 'hidden';
	element.style.height = 0;
	element.style.paddingTop = 0;
	element.style.paddingBottom = 0;
	element.style.marginTop = 0;
	element.style.marginBottom = 0;

	setTimeout(() => {
		element.style.display = 'none';

		// Reset all styles
		element.style.removeProperty('height');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition');

		// Optionally reset to original
		element.style.paddingTop = paddingTop;
		element.style.paddingBottom = paddingBottom;
		element.style.marginTop = marginTop;
		element.style.marginBottom = marginBottom;

		if (typeof callback === 'function') {
			callback();
		}
	}, duration);
};

export const slideDown = (element, duration = 500, callback = null) => {
	element.style.removeProperty('display');
	let display = window.getComputedStyle(element).display;

	if (display === 'none') {
		display = 'block';
	}
	element.style.display = display;

	const height = element.offsetHeight;
	element.style.overflow = 'hidden';
	element.style.height = 0;
	element.style.paddingTop = 0;
	element.style.paddingBottom = 0;
	element.style.marginTop = 0;
	element.style.marginBottom = 0;

	element.offsetHeight; // force reflow

	// element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
	element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
	element.style.height = `${height}px`;
	element.style.removeProperty('padding-top');
	element.style.removeProperty('padding-bottom');
	element.style.removeProperty('margin-top');
	element.style.removeProperty('margin-bottom');

	setTimeout(() => {
		element.style.removeProperty('height');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition');

		if (typeof callback === 'function') {
			callback();
		}
	}, duration);
};

export const slideToggle = (element, duration = 500) => {
	if (window.getComputedStyle(element).display === 'none') {
		slideDown(element, duration);
	} else {
		slideUp(element, duration);
	}
};
/* Slide Up, Down and Toggle Fucntion End */

/* same-height element start */
export const sameHeight = (elemSelector, heightType) => {
	const elements = document.querySelectorAll(elemSelector);
	let maxHeight = 0;
	heightType = heightType === undefined ? 'min-height' : 'height';
	elements.forEach((el) => {
		el.style[heightType] = 'auto';
	});
	elements.forEach((el) => {
		const height = el.offsetHeight;
		if (height > maxHeight) {
			maxHeight = height;
		}
	});
	elements.forEach((el) => {
		el.style[heightType] = `${maxHeight}px`;
	});
};
/* same-height element end */

/* Fade In function Start */
export const updateFocusedClass = (selector) => {
	selector.forEach((field) => {
		const value = field.value;
		const fieldWrap = field.closest('.gfield');

		if (value && value !== '(___) ___-____') {
			fieldWrap.classList.add('focused');
		} else {
			fieldWrap.classList.remove('focused', 'focused_effect');
		}

		field.addEventListener('focus', () => {
			field.closest('.gfield').classList.add('focused', 'focused_effect');
		});

		field.addEventListener('blur', () => {
			const value = field.value;
			const fieldWrap = field.closest('.gfield');

			if (!value || value === '(___) ___-____') {
				fieldWrap.classList.remove('focused', 'focused_effect');
			} else {
				fieldWrap.classList.add('focused');
			}
			fieldWrap.classList.remove('focused_effect');
		});
	});
};
/* form focus end */

// Fade In function
export const fadeIn = (el, duration = 400) => {
	el.style.opacity = 0;
	el.style.display = 'block';
	const start = performance.now();

	function animate(time) {
		let progress = (time - start) / duration;
		if (progress > 1) {
			progress = 1;
		}
		el.style.opacity = progress;
		if (progress < 1) {
			requestAnimationFrame(animate);
		}
	}
	requestAnimationFrame(animate);
};
/* Fade In function End */

/* Resource Gated Form Modal Functionality */
export const initResourceModal = () => {
	const openButtons = document.querySelectorAll('.js-open-gate-modal');
	const modals = document.querySelectorAll('.popup-modal');

	if (!openButtons.length && !modals.length) {
		return;
	}

	const getCookie = (name) => {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	};

	const setResourceCookie = (postId) => {
		const maxAge = 30 * 24 * 60 * 60; // 30 days
		document.cookie = `wp_resource_unlocked=1; path=/; max-age=${maxAge}; SameSite=Lax`;
		if (postId) {
			document.cookie = `wp_resource_${postId}_unlocked=; path=/; max-age=0`;
		}
	};

	const updateButtonToDirectLink = (button, fileUrl, downloadText) => {
		if (!button || !fileUrl) return;
		button.classList.remove('js-open-gate-modal');
		button.setAttribute('href', fileUrl);
		button.setAttribute('target', '_blank');
		button.setAttribute('rel', 'noopener noreferrer');
		button.removeAttribute('data-modal');
		button.removeAttribute('role');
		if (downloadText) {
			button.textContent = downloadText;
		}
	};

	// 1. Check if resource is already unlocked via cookie on page load
	openButtons.forEach((button) => {
		const postId = button.getAttribute('data-post-id');
		const fileUrl = button.getAttribute('data-file-url');
		const downloadText = button.getAttribute('data-download-text');
		const isUnlocked = getCookie('wp_resource_unlocked') === '1' || (postId && getCookie(`wp_resource_${postId}_unlocked`) === '1') || getCookie('cobalt_resource_unlocked') === '1';

		if (isUnlocked && fileUrl) {
			updateButtonToDirectLink(button, fileUrl, downloadText);
		}
	});

	const openModal = (modal) => {
		if (!modal) return;
		modal.classList.add('is-active');
		modal.setAttribute('aria-hidden', 'false');
		document.body.classList.add('modal-open');
		const closeBtn = modal.querySelector('.popup-close');
		if (closeBtn) {
			closeBtn.focus();
		}
	};

	const closeModal = (modal) => {
		if (!modal) return;
		modal.classList.remove('is-active');
		modal.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('modal-open');
	};

	document.addEventListener('click', (e) => {
		const button = e.target.closest('.js-open-gate-modal, [data-modal="resource-gate-modal"], a[href="#resource-gate-modal"]');
		if (!button) return;
		if (!button.classList.contains('js-open-gate-modal')) {
			return; // Already unlocked, allowed to perform direct link
		}
		e.preventDefault();
		const targetId = button.getAttribute('data-modal') || (button.getAttribute('href') ? button.getAttribute('href').replace('#', '') : 'resource-gate-modal');
		const modal = document.getElementById(targetId) || document.querySelector('.resource-gate-modal');
		if (modal) {
			openModal(modal);
		}
	});

	modals.forEach((modal) => {
		modal.querySelectorAll('.js-close-gate-modal').forEach((closeEl) => {
			closeEl.addEventListener('click', (e) => {
				e.preventDefault();
				closeModal(modal);
			});
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && modal.classList.contains('is-active')) {
				closeModal(modal);
			}
		});
	});

	// 2. Handle Gravity Form successful submission
	const handleFormSubmissionSuccess = (modal) => {
		if (!modal || modal.dataset.downloadTriggered === 'true') return;
		modal.dataset.downloadTriggered = 'true';

		const fileUrl = modal.getAttribute('data-file-url');
		const postId = modal.getAttribute('data-post-id');

		// Set cookie
		setResourceCookie(postId);

		// Convert hero button on page to direct download link
		const heroButtons = document.querySelectorAll(`.js-open-gate-modal[data-post-id="${postId}"], .js-open-gate-modal`);
		heroButtons.forEach((btn) => {
			const downloadText = btn.getAttribute('data-download-text');
			updateButtonToDirectLink(btn, fileUrl, downloadText);
		});

		// Ensure direct link is in confirmation message
		const confirmWrap = modal.querySelector('.gform_confirmation_message') || modal.querySelector('.popup-form');
		if (confirmWrap && fileUrl && !confirmWrap.querySelector('.js-direct-download-link')) {
			const linkWrap = document.createElement('div');
			linkWrap.className = 'gform-direct-download-wrap';
			linkWrap.style.marginTop = '20px';
			linkWrap.innerHTML = `<a href="${fileUrl}" target="_blank" rel="noopener noreferrer" class="btn pd-hero-btn js-direct-download-link">Download File</a>`;
			confirmWrap.appendChild(linkWrap);
		}

		// User sees brief thank you, then redirected to file in a new tab
		if (fileUrl) {
			setTimeout(() => {
				window.open(fileUrl, '_blank');
			}, 1000);
		}
	};

	// Listen for Gravity Forms AJAX confirmation
	if (typeof window !== 'undefined') {
		const attachGFormHandler = () => {
			if (window.jQuery) {
				window.jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
					const modal = document.querySelector('.resource-gate-modal, #resource-gate-modal');
					if (modal) {
						handleFormSubmissionSuccess(modal);
					}
				});
			} else {
				setTimeout(attachGFormHandler, 200);
			}
		};
		attachGFormHandler();
	}

	// MutationObserver fallback on .popup-form in case DOM replaces before event
	modals.forEach((modal) => {
		const popupForm = modal.querySelector('.popup-form');
		if (popupForm && window.MutationObserver) {
			const observer = new MutationObserver(() => {
				if (popupForm.querySelector('.gform_confirmation_message')) {
					handleFormSubmissionSuccess(modal);
				}
			});
			observer.observe(popupForm, { childList: true, subtree: true });
		}
	});
};
